import React, { useEffect } from "react";
import "./instarecipes-privacy-policy.css";

function InstaRecipesPrivacyPolicy() {
  useEffect(() => {
    document.title = "InstaRecipes Privacy Policy";
  }, []);

  return (
    <main className="privacy-page">
      <article className="privacy-page__content" aria-labelledby="privacy-title">
        <h1 id="privacy-title">Privacy Policy</h1>
        <p className="privacy-page__updated">Last updated: March 4, 2026.</p>

        <h2>1.0 Information We Collect</h2>
        <p>
          The InstaRecipes App is committed to protecting the privacy of its
          users. We do not collect any personal data from our users, nor do we
          track any user data. We do not share or sell any user information to
          third parties.
        </p>
        <p>We do not collect and store any information from users.</p>

        <h2>1.1 Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. We will notify
          you of any changes by posting the new Privacy Policy on this page and
          by showing a message in the app. These changes are effective
          immediately after they are posted on this page.
        </p>

        <h2>1.2 Contact Us</h2>
        <p>
          If you have any questions or suggestions about our Privacy Policy, do
          not hesitate to contact us at{" "}
          <a href="mailto:carlosmsilva83@gmail.com">carlosmsilva83@gmail.com</a>.
        </p>
      </article>
    </main>
  );
}

export default InstaRecipesPrivacyPolicy;
